import {
  FOLLOW_MY_CASE_FAIL,
  FOLLOW_MY_CASE_START,
  FOLLOW_MY_CASE_SUCCESS,
  GET_CASE_FAIL,
  GET_CASE_START,
  GET_CASE_SUCCESS,
} from './types';
import { createAction, getActionList } from './action-utils';
import { CaseData } from 'ts/types/case.types';

const actions = {
  getCaseStart: ({ id }: { id: string }) =>
    createAction(GET_CASE_START, { id }),
  getCaseSuccess: (payload: CaseData) =>
    createAction(GET_CASE_SUCCESS, payload),
  getCaseFail: (error: any) => createAction(GET_CASE_FAIL, { error }),
  followMyCaseSuccess: (caseGuid: string) =>
    createAction(FOLLOW_MY_CASE_SUCCESS, { caseGuid }),
  followMyCaseStart: () => createAction(FOLLOW_MY_CASE_START, {}),
  followMyCaseFail: (error: any) =>
    createAction(FOLLOW_MY_CASE_FAIL, { error }),
};

export default actions;

const actionList = getActionList(actions);

export type CaseActionType = typeof actionList[number];
